<div class="row">
  <div class="col-12">
    <div class="row align-items-center mb-3">
      <div class="col-12 col-sm-2 mb-1">
        <label for="bundle">{{ 'serviceData.form.bundle' | translate }}</label>
      </div>
      <div class="col-10 col-sm-9">
        @if (bundles$ | async; as bundles) {
          <app-select
            id="bundle"
            data-cy="Bundle-select"
            [formControl]="bundleFormControl"
            [placeholder]="
              bundles.length
                ? ('serviceData.form.placeholders.selectBundle' | translate)
                : ('serviceData.form.placeholders.noBundlesAvailable'
                  | translate)
            "
          >
            @for (bundle of bundles; track bundle) {
              <app-select-option
                [value]="bundle?.id"
                [label]="bundle?.internalName"
              />
            }
          </app-select>
        } @else {
          <app-select
            data-cy="Bundle-select-disabled"
            [placeholder]="
              'serviceData.form.placeholders.selectPartnerFirst' | translate
            "
            [formControl]="bundleFormControl"
          />
        }
      </div>
      <div class="col-2 col-sm-1">
        <button
          class="icon-btn icon-btn-lg"
          ngbTooltip="{{
            'serviceData.form.tooltips.assignBundleToServiceData' | translate
          }}"
          triggers="hover"
          placement="left"
          data-cy="assign-bundle-btn"
          [disabled]="
            bundleFormControl.disabled ||
            !bundleFormControl?.value ||
            form.get('bundleIds').value?.length
          "
          (click)="assignBundle()"
        >
          <i class="fa-light fa-plus"></i>
        </button>
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-md-10">
        <app-data-table [configuration]="dataTableConfiguration" />
      </div>
    </div>
    <div class="row justify-content-end mb-3">
      <div class="col-10">
        <app-validation-error
          for="bundleIds"
          translations="serviceData.form.validation.bundles"
          data-cy="Bundle-validation-error"
        ></app-validation-error>
      </div>
    </div>
  </div>

  <ng-container formGroupName="serviceInformation">
    <ng-container formGroupName="nipt">
      @if (fieldSet.includes(ServiceDataFields.GenderInformation)) {
        <div
          class="row mb-3"
          *appRequirePermission="id ? ['medicalInformation'] : []"
        >
          <div class="col-12 col-md-6">
            <div class="row align-items-center">
              <div class="col-12 col-sm-6 col-md-4 mb-1">
                <label for="provideGenderInformation">{{
                  'serviceData.form.provideGenderInformation' | translate
                }}</label>
              </div>
              <div class="col-12 col-sm-6 col-md-8">
                <div class="col-9">
                  <div class="form-check form-check-inline form-check-lg">
                    <input
                      id="provideGenderInformationYes"
                      class="form-check-input me-2"
                      type="radio"
                      formControlName="provideGenderInformation"
                      [attr.data-cy]="
                        ServiceDataFields.GenderInformation + '-radio-yes'
                      "
                      [value]="true"
                    />
                    <label
                      class="form-check-label"
                      for="provideGenderInformationYes"
                    >
                      {{ 'common.yes' | translate }}
                    </label>
                  </div>
                  <div class="form-check form-check-inline form-check-lg">
                    <input
                      id="provideGenderInformationNo"
                      class="form-check-input me-2"
                      type="radio"
                      formControlName="provideGenderInformation"
                      [attr.data-cy]="
                        ServiceDataFields.GenderInformation + '-radio-no'
                      "
                      [value]="false"
                    />
                    <label
                      class="form-check-label"
                      for="provideGenderInformationNo"
                    >
                      {{ 'common.no' | translate }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-sm-6 col-md-8">
                <app-validation-error
                  for="provideGenderInformation"
                  translations="validation.generic"
                  [attr.data-cy]="
                    ServiceDataFields.GenderInformation + '-validation-error'
                  "
                ></app-validation-error>
              </div>
            </div>
          </div>
        </div>
      }
      @if (
        fieldSet.includes(ServiceDataFields.IncidentalFindings) &&
        form.get('serviceInformation.nipt.incidentalFindings').enabled
      ) {
        <div
          class="row mb-3"
          *appRequirePermission="id ? ['medicalInformation'] : []"
        >
          <div class="col-12 col-md-6">
            <div class="row align-items-center">
              <div class="col-12 col-sm-6 col-md-4 mb-1">
                <label for="incidentalFindings">{{
                  'serviceData.form.incidentalFindings' | translate
                }}</label>
              </div>
              <div class="col-12 col-sm-6 col-md-8">
                <div class="col-9">
                  <div class="form-check form-check-inline form-check-lg">
                    <input
                      id="incidentalFindingsYes"
                      class="form-check-input me-2"
                      type="radio"
                      formControlName="incidentalFindings"
                      [attr.data-cy]="
                        ServiceDataFields.IncidentalFindings + '-radio-yes'
                      "
                      [value]="true"
                    />
                    <label class="form-check-label" for="incidentalFindingsYes">
                      {{ 'common.yes' | translate }}
                    </label>
                  </div>
                  <div class="form-check form-check-inline form-check-lg">
                    <input
                      id="incidentalFindingsNo"
                      class="form-check-input me-2"
                      type="radio"
                      formControlName="incidentalFindings"
                      [attr.data-cy]="
                        ServiceDataFields.IncidentalFindings + '-radio-no'
                      "
                      [value]="false"
                    />
                    <label class="form-check-label" for="incidentalFindingsNo">
                      {{ 'common.no' | translate }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-sm-6 col-md-8">
                <app-validation-error
                  for="incidentalFindings"
                  translations="validation.generic"
                  [attr.data-cy]="
                    ServiceDataFields.IncidentalFindings + '-validation-error'
                  "
                ></app-validation-error>
              </div>
            </div>
          </div>
        </div>
      }
    </ng-container>
  </ng-container>
  <ng-container formGroupName="serviceInformation">
    <ng-container formGroupName="paternity">
      @if (fieldSet.includes(ServiceDataFields.ParentingTestType)) {
        <div
          class="row mb-3"
          *appRequirePermission="id ? ['medicalInformation'] : []"
        >
          <div class="col-12 col-md-6">
            <div class="row align-items-center">
              <div class="col-12 col-sm-6 col-md-4 mb-1">
                <label for="parentingTestType">{{
                  'serviceData.form.parentingTestType' | translate
                }}</label>
              </div>
              <div class="col-12 col-sm-6 col-md-8">
                <app-select
                  class="w-100"
                  id="parentingTestType"
                  formControlName="parentingTestType"
                  [attr.data-cy]="
                    ServiceDataFields.ParentingTestType + '-select'
                  "
                  [placeholder]="
                    'serviceData.form.placeholders.parentingTestType'
                      | translate
                  "
                >
                  @for (type of parentingTestTypes; track type) {
                    <app-select-option
                      [value]="type"
                      [label]="
                        'serviceData.parentingTestType.' + type | translate
                      "
                    />
                  }
                </app-select>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-sm-6 col-md-8">
                <app-validation-error
                  for="parentingTestType"
                  translations="validation.generic"
                  [attr.data-cy]="
                    ServiceDataFields.ParentingTestType + '-validation-error'
                  "
                />
              </div>
            </div>
          </div>
        </div>
      }
    </ng-container>
    <ng-container formGroupName="mono">
      @if (
        fieldSet.includes(ServiceDataFields.MonogenicIncidentalFindings) &&
        form.get('serviceInformation.mono.monogenicIncidentalFindings').enabled
      ) {
        <div
          class="row mb-3"
          *appRequirePermission="id ? ['medicalInformation'] : []"
        >
          <div class="col-12 col-md-6">
            <div class="row align-items-center">
              <div class="col-12 col-sm-6 col-md-4 mb-1">
                <label for="monogenicIncidentalFindings">{{
                  'serviceData.form.monogenicIncidentalFindings' | translate
                }}</label>
              </div>
              <div class="col-12 col-sm-6 col-md-8">
                <div class="col-9">
                  <div class="form-check form-check-inline form-check-lg">
                    <input
                      id="monogenicIncidentalFindingsYes"
                      class="form-check-input me-2"
                      type="radio"
                      formControlName="monogenicIncidentalFindings"
                      [attr.data-cy]="
                        ServiceDataFields.MonogenicIncidentalFindings +
                        '-radio-yes'
                      "
                      [value]="true"
                    />
                    <label
                      class="form-check-label"
                      for="monogenicIncidentalFindingsYes"
                    >
                      {{ 'common.yes' | translate }}
                    </label>
                  </div>
                  <div class="form-check form-check-inline form-check-lg">
                    <input
                      id="monogenicIncidentalFindingsNo"
                      class="form-check-input me-2"
                      type="radio"
                      formControlName="monogenicIncidentalFindings"
                      [attr.data-cy]="
                        ServiceDataFields.MonogenicIncidentalFindings +
                        '-radio-no'
                      "
                      [value]="false"
                    />
                    <label
                      class="form-check-label"
                      for="monogenicIncidentalFindingsNo"
                    >
                      {{ 'common.no' | translate }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-sm-6 col-md-8">
                <app-validation-error
                  for="monogenicIncidentalFindings"
                  translations="validation.generic"
                  [attr.data-cy]="
                    ServiceDataFields.MonogenicIncidentalFindings +
                    '-validation-error'
                  "
                ></app-validation-error>
              </div>
            </div>
          </div>
        </div>
      }
    </ng-container>
  </ng-container>
</div>
